export default "__VITE_ASSET__C3_1_NrD__"